import './styles/Subheading.scss';

import { ReactElement } from 'react';

interface Props {
  component?: React.ElementType<any>;
  content: string;
}

export default function Subheading({ component: Component, content }: Props): ReactElement {
  if (Component) {
    return <Component className="detail-page-subheading">{content}</Component>;
  }
  return <h2 className="detail-page-subheading">{content}</h2>;
}
